import React, { useCallback, useContext, useMemo } from 'react';
import styled from 'styled-components';
import { FormModal, MainLabel, SelectField as BaseSelectField } from '@ubeya/shared-web/components';
import useUser from '@ubeya/shared/hooks/auth/useUser';
import { getDirtyFields } from '@ubeya/shared/utils/form';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import useToaster from '@ubeya/shared/hooks/useToaster';
import useGenericSettings from '@ubeya/shared/hooks/generic/useGenericSettings';
import useAccount from '@ubeya/shared/hooks/account/useAccount';
import NotificationsSettings from './NotificationsSettings';

const SelectField = styled(BaseSelectField)`
  width: 50%;
`;

const ProfileModal = ({ onClose, configInitialData, update }) => {
  const { t } = useContext(ConfigContext);
  const { data } = useUser();
  const { account, config } = useAccount();
  const { addSuccess, addError } = useToaster();
  const { languagesOptions } = useGenericSettings();

  const handleSubmit = useCallback(
    async (values, form) => {
      const { dirtyFields } = form.getState();
      const dirtyValues = getDirtyFields(values, dirtyFields);

      try {
        await update(dirtyValues);
        addSuccess(t('notificationSettingsUpdated'));
        onClose();
      } catch (error) {
        addError(t('notificationSettingsUpdateFailed'));
        throw error;
      }
    },
    [addError, addSuccess, onClose, t, update]
  );

  const initialValues = useMemo(
    () => ({ ...data, config: configInitialData, adminSettings: { languageId: account.languageId } }),
    [configInitialData, data, account.languageId]
  );

  const showClientSelfServiceBooking = !!config.enableClientSelectEmployeesFeature;

  return (
    <FormModal initialValues={initialValues} onSubmit={handleSubmit} onClose={onClose} title={t('myAdminSettings')}>
      <MainLabel>{t('notifications')}</MainLabel>
      <NotificationsSettings showClientSelfServiceBooking={showClientSelfServiceBooking} />
      <MainLabel>{t('other')}</MainLabel>
      <SelectField
        name="adminSettings.languageId"
        title={t('adminPlatformLanguage')}
        options={languagesOptions}
        isMulti={false}
      />
    </FormModal>
  );
};

export default ProfileModal;
